import { createContext, useContext, useEffect, useRef } from "react";
import Lenis from "lenis";
import { useLocation, useNavigate } from "react-router-dom";

const LenisCtx = createContext({ current: null });

export const SmoothScroll = ({ children }) => {
  const ref = useRef(null);
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    ref.current = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); ref.current = null; };
  }, []);
  return <LenisCtx.Provider value={ref}>{children}</LenisCtx.Provider>;
};

export const useScrollTo = () => {
  const ref = useContext(LenisCtx);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  return (target, e) => {
    if (pathname !== "/") {
      e?.preventDefault();
      navigate(target === 0 ? "/" : `/#${target}`);
      return;
    }
    e?.preventDefault();
    const dest = target === 0 ? 0 : `#${target}`;
    if (ref.current) ref.current.scrollTo(dest, { offset: -84 });
    else if (target === 0) window.scrollTo({ top: 0, behavior: "smooth" });
    else document.getElementById(target)?.scrollIntoView({ behavior: "smooth" });
  };
};
